
import {
  Button,
  Typography,
} from "@mui/material";


import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import PatientDetailsComponent from "../vitals/components/DetailsCard";
import TriageList from "./components/TriageList";
const NursingTriage = () => {


  const navigate = useNavigate();
  const naviagateBack = () => {
    navigate(-1);
  };
  return (
    <>
      <div className="flex justify-between">
        <Typography
          variant="h6"
          fontSize={".9rem"}
          fontWeight={"600"}
          className="text-blue-900 ps-3 pt-3"
        >
         Nursing   Triage
        </Typography>

        <Button
          startIcon={<ArrowBack />}
          className="!mt-5 !mr-5"
          color="error"
          onClick={naviagateBack}
        >
          Back
        </Button>
      </div>
      <div className="p-1  grid grid-cols gap-y-5">
        <PatientDetailsComponent />
        <div className="mx-2"><TriageList/></div>
      </div>
    </>
  );
};



export default NursingTriage;
